import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import form from '@style/form';
import modal from '@style/modal';
import styles from '@components/orders/modals/new-order/styles';
import combineStyles from "~/utils/styles";
import RemoteAutocompleteSelect from '@components/form/RemoteAutocompleteSelect';
import Grid from "@material-ui/core/Grid";
import {StandartInput} from "@components/form/StandartInput";

const UtmTableComponent = (props) => {
    let {utm = {}, classes, errors, onChange, onSelectSource, isEditable} = props;

    const [value, setValue] = React.useState(false);

    function setUtms(data) {
        const {utm_source, utm_medium, utm_campaign, utm_term, utm_content} = data;

        onSelectSource({
            utm_source,
            utm_medium,
            utm_campaign,
            utm_term,
            utm_content
        });
    }

    const input = (key) => <StandartInput
        disabled={!isEditable}
        name={key}
        label={key}
        value={utm[key] || ''}
        errors={errors}
        errorSubKey={'utm'}
        onChange={onChange}
        className={classes.input}
        variant={'outlined'}
        margin={'normal'}
        size={'small'}
        fullWidth
    />

    return (<Grid container spacing={3} className={classes.gridSubContainer}>
            <Grid item xs={12} md={6} lg={4}>
                <RemoteAutocompleteSelect
                    name={'category_id'}
                    url={'/api/v1/utm/autocomplete'}
                    value={value}
                    label="Доступные источники"
                    onChange={(e, object) => {
                        setValue(object.value);
                        setUtms(object);
                    }}
                    disabled={!isEditable}
                    className={classes.input}
                    variant={'outlined'}
                    margin={'normal'}
                    size={'small'}
                    fullWidth
                />
            </Grid>

            <Grid item xs={12} className={classes.resetPaddingLeft_downMd}>
                <Grid container spacing={3} className={classes.utmSubContainer}>
                    {Object.keys(utm).map((key) => (
                        <Grid item xs={12} md={6} lg={4} key={key}>
                            {input(key)}
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export const UtmTable = withStyles(combineStyles(form, modal, styles))(UtmTableComponent);
